"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ThemeProviderProps } from "next-themes";

/**
 * アプリ全体のダークモード・ライトモードを管理するコンポーネントです。
 * マネノビAIの高級感のあるネイビーを正しく表示するために必要です。
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
